import { useRouteError } from 'react-router-dom';
import { AppUpdatedPage } from '@/pages/error/AppUpdatedPage';
import { isChunkLoadError } from '@/lib/lazy-with-reload';

// `errorElement` de la raíz del router. Solo se ocupa del caso "el deploy se
// llevó el chunk": cualquier otro error se relanza para que lo tome el
// ErrorBoundary global (`src/components/error-boundary.tsx`), que es el que
// reporta a Sentry. Sin el relanzamiento, montar un errorElement en la raíz
// dejaría a ese boundary sin ver nunca un error de render de página.
export const RouteErrorBoundary = () => {
  const error = useRouteError();
  if (!isChunkLoadError(error)) throw error;

  const detail = error instanceof Error ? error.message : undefined;
  return <AppUpdatedPage detail={detail} />;
};
